(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup-mille"]) return;
  try {
    
(function(){
  var root=document.getElementById('mr-newspop');
  if(!root)return;
  var KEY_D='mille_np_dismissed',KEY_S='mille_np_subscribed';
  var ls=null;try{ls=window.localStorage;ls.setItem('_np_t','1');ls.removeItem('_np_t');}catch(e){ls=null;}
  var days=parseInt(root.getAttribute('data-days'),10)||30;
  var delay=(parseInt(root.getAttribute('data-delay'),10)||7)*1000;
  var flag=root.querySelector('.np-flag');
  var state=flag?flag.getAttribute('data-state'):null;
  if(!state&&/[?&]customer_posted=true/.test(location.search)){state='posted';}
  function show(){
    root.classList.add('np-open');
    document.documentElement.classList.add('mrnp-lock');
    var inp=root.querySelector('.np-in');
    if(inp&&!state){setTimeout(function(){inp.focus();},380);}
  }
  function hide(remember){
    root.classList.remove('np-open');
    document.documentElement.classList.remove('mrnp-lock');
    if(remember&&ls){ls.setItem(KEY_D,String(Date.now()));}
  }
  root.querySelectorAll('[data-np-close]').forEach(function(el){
    el.addEventListener('click',function(){hide(state!=='posted');});
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&root.classList.contains('np-open')){hide(state!=='posted');}
  });
  if(state==='posted'){
    if(ls){ls.setItem(KEY_S,'1');ls.removeItem(KEY_D);}
    show();
    return;
  }
  if(state==='error'){show();return;}
  if(ls){
    if(ls.getItem(KEY_S)){return;}
    var d=parseInt(ls.getItem(KEY_D),10)||0;
    if(Date.now()-d<days*86400000){return;}
  }
  setTimeout(show,delay);
  document.addEventListener('shopify:section:select',function(e){
    if(e.target&&e.target.contains(root)){show();}
  });
  document.addEventListener('shopify:section:deselect',function(e){
    if(e.target&&e.target.contains(root)){hide(false);}
  });
})();

  } catch(e) { console.error(e); }
})();
})();
